import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default /*@__PURE__*/Object.assign({
  name: 'SpotItem'
}, {
  __name: 'SpotItem',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    // 定义 props
    const props = __props;

    // 状态类型列表
    const typeList = ['info', 'primary', 'success', 'error', 'none', 'reject'];

    // 计算当前项
    const item = computed(() => {
      const {
        value,
        list
      } = props;
      let result = {
        label: '--',
        spot: 4
      };
      if (list && list.length > 0) {
        result = list.find(son => {
          let sonVal = son.value;
          sonVal = String(sonVal).split('&');
          return sonVal.includes(String(value));
        }) || result;
      }
      return result;
    });

    // 计算状态值
    const spotVal = computed(() => {
      const {
        spot,
        value
      } = item.value;
      let val = spot;
      if (spot === undefined) val = value;
      return parseInt(val, 10);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(['spot-item', typeList[spotVal.value]])
      }, _toDisplayString(item.value.label), 3);
    };
  }
});